import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

let req_url, req_url2, req_url3, static_img_url, img_req_url, index_path, index2_path, vbef_path, loginWxAppId, activityId, domain_path, cookie_type, paypalScript
if (process.env.NODE_ENV == 'development') {
  // 本地环境
  req_url = '/php'
  req_url2 = '/vbef'
  req_url3 = '/appapi'

  static_img_url = 'http://localhost:9002/'
  img_req_url = 'https://static-cdn-test.vbdata.cn'

  index_path = 'https://t-fe.vbdata.cn'
  index2_path = 'https://t-www.vbdata.cn'
  vbef_path = 'http://localhost:9002'

  loginWxAppId = 'wx93f12cd83e68833d' 
  activityId = 1000

  domain_path = 'localhost'
  cookie_type = 1

  paypalScript = 'https://www.sandbox.paypal.com/web-sdk/v6/core'
} else {
  if (process.env.VUE_APP_FLAG === 'pro') {
    // 生产环境
    req_url = window.location.protocol + '//api.vbdata.cn'
    req_url2 = window.location.protocol + '//vb100-api.vcbeat.top'
    req_url3 = window.location.protocol + '//app.vbdata.cn'
    index_path = 'https://vbdata.cn'
    index2_path = 'https://www.vbdata.cn'
    vbef_path = 'https://www.csgct.com.cn'

    static_img_url = 'https://static-cdn.vbdata.cn/csgct-fe/'
    img_req_url = 'https://cdn.vbdata.cn'

    loginWxAppId = 'wx93f12cd83e68833d'
    activityId = 1031	

    domain_path = 'csgct.com.cn'
    cookie_type = 3

    paypalScript = 'https://www.paypal.com/web-sdk/v6/core'
  } else {
    // 测试环境
    req_url = window.location.protocol + '//t-api.vbdata.cn'
    req_url2 = window.location.protocol + '//t-vb100-api.vcbeat.top'
    req_url3 = window.location.protocol + '//t-app-api.vbdata.cn'

    static_img_url = 'https://static-cdn-test.vbdata.cn/csgct-fe/'
    img_req_url = 'https://static-cdn-test.vbdata.cn'

    index_path = 'https://t-fe.vbdata.cn'
    index2_path = 'https://t-www.vbdata.cn'
    vbef_path = 'https://t-www.csgct.com.cn'

    loginWxAppId = 'wx93f12cd83e68833d'
    activityId = 1000

    domain_path = 'csgct.com.cn'
    cookie_type = 2
    
    paypalScript = 'https://www.sandbox.paypal.com/web-sdk/v6/core'
  }
}

const userAgent = navigator.userAgent.toLowerCase();
// 检查是否是移动设备
const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
const isWeixinBrowser = /micromessenger/i.test(userAgent);



export default new Vuex.Store({
  state: {
    req_url,
    req_url2,
    req_url3,

    static_img_url,
    img_req_url,

    index_path,
    index2_path,
    vbef_path,

    loginWxAppId,

    isMobile,
    isWeixinBrowser,

    domain_path,
    cookie_type,

    paypalScript,

    user: '',
    user_key: '',
    uuserId: '',
    uuid: '',

    activityId,
    activityDetail: {},

    firstLoad: 1,

    mainPageContent: [],
    contentNav: [],
    language: 'en',  // zh,en
    imgVersion: '2026012301',
    btnBanner: [],
    moduleList: [
      {id: 1, name: 'NEWS'},
      {id: 2, name: 'China CGT 100 Pioneers'},
    ]
  },
  mutations: {
    updateDict(state, values) {
      for (let item in values) {
        if (!state[item]) {
          state[item] = values[item]
        }
      }
    },
    setUUid(state, values) {
      state.uuid = values
    },
    setUUserId(state, values) {
      state.uuserId = values
    },
    updateUser(state, values) {
      state.user = values
    },
    updateUserKey(state, values) {
      state.user_key = values
      if (values) {
        Cookies.set('user_key_' + cookie_type, values, { domain: domain_path, path: '/' })
      } else {
        Cookies.remove('user_key_' + cookie_type, { domain: domain_path })
      }
    },
    updateInterimUserKey(state, values) {
      state.user_key = values || ''
    },
    updateActivity(state, values) {
      state.activityDetail = values
    },
    setFirstLoad(state, values) {
      state.firstLoad = values
    },
    updateMainPageContent(state, values) {
      state.mainPageContent = values.filter(item => item.type != '0')
      state.contentNav = values.filter(item => item.type == '0')
    },
    setLanguage(state, values) {
      state.language = values
    },
    setBtnBanner(state, values) {
      state.btnBanner = values
    }
  }
})
